import {EventEditor} from "./EventEditor";

export class StartNodeEditor extends EventEditor {
	constructor(parent, node, coords) {
		super(parent, node, coords);
	}
}